import { UserEvent } from '@/types/UserEvent';
import { getUserEvents } from '@/utils/get-user-events';
import { useState, useEffect } from 'react';
import GuestActivityHeatmap from './GuestActivityHeatmap';
import Link from 'next/link';
import { Button } from './ui/button';

const GuestStats = () => {
  const [userEvents, setUserEvents] = useState<UserEvent[]>([]);

  useEffect(() => {
    const getEvents = async () => {
      const { data: userEvents, error } = await getUserEvents();
      if (!error) {
        setUserEvents(userEvents);
      }
    };

    getEvents();
  }, []);

  // TO-DO: Add this to the UI with a big counter
  // {`You have reviewed ${reviewsCount} examples`}
  return (
    <div className="gcontainer">
      <div className="flex flex-col items-center justify-center pb-4">
        <Button asChild size="lg">
          <Link href="/login" className="mx-auto py-4">
            {`Sign in for free to get more detailed stats and optional email reminders`}
          </Link>
        </Button>
      </div>
      <GuestActivityHeatmap userEvents={userEvents} />
    </div>
  );
};

export default GuestStats;
